import React, { useEffect, useRef } from "react";
import './HomePage.scss';
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function HomePage({ CitiesData, UserSession, ZipCode, setZipCode, ProjectList, ServicesData, setUpdateApp }) {
    const [Render, setRender] = useState();
    const [ShowSearch, setShowSearch] = useState(false);
    const [SearchQuery, setSearchQuery] = useState("");
    const [ServicesDataNew, setServicesDataNew] = useState([]);
    const [ServicesDataNewSubCategory, setServicesDataNewSubCategory] = useState([]);

    const url = new URL(window.location.href);
    let arr = Array.apply(null, { length: 10 }).map(Number.call, Number);

    const containerRefService = useRef(null);
    const scrollRightService = () => {
        if (containerRefService.current) {
            containerRefService.current.scrollLeft += 270; // Adjust scroll distance as needed
        }
    };
    const containerRefProjects = useRef(null);
    const scrollRightProjects = () => {
        if (containerRefProjects.current) {
            containerRefProjects.current.scrollLeft += 320; // Adjust scroll distance as needed
        }
    };

    useEffect(() => {
        // Convert Main Servcies Data to one data include All (SubCategory)
        let arrray = []
        for (let index = 0; index < ServicesData.length; index++) {
            for (let index2 = 0; index2 < ServicesData[index].sub_services.length; index2++) {
                // console.log(arrray);
                arrray.push(ServicesData[index].sub_services[index2])
            }
        }
        setServicesDataNew(arrray.sort())
        setServicesDataNewSubCategory(arrray.sort());
        console.log();
        // 
        // (async () => {
        //     const res1 = await fetch('https://api.p.2chat.io/open/whatsapp/send-message', {
        //         method: 'POST',
        //         headers: {
        //             'X-User-API-Key': 'UAKdd094d66-3fa7-414f-8e0d-e2f640116e93',
        //             'Content-Type': 'application/json'
        //         },
        //         // body: '{\n    "to_number": "+5215512345432",\n    "from_number": "+595981048477",\n    "text": "Test from 2Chat API",\n    "url": "https://uploads-ssl.webflow.com/6281a9c52303343ff7c3b269/62a1648ee0273340bf38e3a9_logo-2C.svg"\n}',
        //         body: JSON.stringify({
        //             'to_number': '+12135694372',
        //             'from_number': '+17867257449',
        //             'text': 'Test from 2Chat API',
        //             // 'url': 'https://uploads-ssl.webflow.com/6281a9c52303343ff7c3b269/62a1648ee0273340bf38e3a9_logo-2C.svg'
        //         })
        //     });
        //     const data1 = await res1.json()
        // })()

    }, []);
    return (
        <div className="HomePage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>HandyBy | Find Verified Home Service Pros Near You</title>

                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="HandyBy | Find Trusted Local Pros" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="HandyBy | Find Trusted Local Pros" data-react-helmet="true" />

                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.handyby.com/og-image.jpg" data-react-helmet="true" />

                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.handyby.com/" data-react-helmet="true" />

                {/* <!-- Maximum of 155 characters --> */}
                <meta name="description" content="HandyBy Connects Homeowners With Verified, Trusted Professionals For All Home Services Including Air Duct Cleaning, HVAC Repair, Chimney Sweep, And Roofing." data-react-helmet="true" />
                <meta name="og:description" property="og:description" content="HandyBy Connects Homeowners With Verified, Trusted Professionals For All Home Services Including Air Duct Cleaning, HVAC Repair, Chimney Sweep, And Roofing." data-react-helmet="true" />

                <meta name="og:site_name" property="og:site_name" content="HandyBy" data-react-helmet="true" />

                <meta name="keywords" content="Find Pros Near Me, Local Contractors, Air Duct Cleaning, Chimney Sweep, Dryer Vent Cleaning, HVAC Services, Roofing Services, Garage Door, Locksmith, Insulation, Home Repair Pros, Verified Professionals, HandyBy" data-react-helmet="true" />
                <link rel="canonical" href="https://www.handyby.com/" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "HandyBy",
                    "url": "https://www.handyby.com/",
                    "logo": "https://www.handyby.com/og-image.jpg",
                    "sameAs": [],
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "contactType": "customer service",
                        "areaServed": "US",
                        "availableLanguage": "en"
                    },
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": "4.9",
                        "reviewCount": "1800"
                    }
                })}</script>
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "name": "HandyBy",
                    "url": "https://www.handyby.com/",
                    "potentialAction": {
                        "@type": "SearchAction",
                        "target": "https://www.handyby.com/category/{search_term_string}",
                        "query-input": "required name=search_term_string"
                    }
                })}</script>
            </Helmet>

            {/* CategoryNav */}
            <div className="CategoryNav">
                <div className="CategoryNavLocation">
                    <h3><img src={require(`../../Images/3d-house.png`)} /> Request Service</h3>
                    <h4>{CitiesData && CitiesData.City ? "In" + CitiesData.City : "Local Pros"} <img src={require(`../../Images/ArrowDown.png`)} /></h4>
                </div>
                <div className="CategoryNavShape">
                    <div className="CategoryNavShapeInside">
                        <h1>HandyBy</h1>
                    </div>
                </div>
            </div>
            {/* HomePageTopBanner */}
            <div className="HomePageTopBanner" >
                <img className="HomePageTopBannerImg" src={require(`../../Images/1-insulation.jpg`)} alt="Chimney Cleaning" onMouseDown={() => {
                    setShowSearch(false)
                }} />
                <div className="HomePageTopBannerText" onMouseDown={() => {
                    setShowSearch(false)
                    setRender(a => !a)

                }} >
                    <h1>Get matched with top-rated pros in your area</h1>
                    <h2>Enter your zip and get matched with up to 3 pros</h2>
                    <div className="HomePageTopBannerTextInputMain" >
                        <div on className="HomePageTopBannerTextInput">
                            <div className="HomePageTopBannerTextInputImg">
                                {ShowSearch && SearchQuery.length ?
                                    <img className="HomePageTopBannerTextInputImg_Close" src={require(`../../Images/closeMenu.png`)} onClick={() => {
                                        setRender(a => !a)
                                        setSearchQuery("")
                                    }} />
                                    :
                                    <img src={require(`../../Images/search1.png`)} />
                                }
                            </div>
                            <div className="HomePageTopBannerTextInputInputs">
                                <input

                                    className="InputQuestion"
                                    placeholder="Tell us what you need help with"
                                    value={SearchQuery}
                                    onClick={() => {
                                        setShowSearch(true)
                                        // window.scrollTo(0, 0)
                                    }}
                                    onChange={(a) => {
                                        setShowSearch(true)
                                        setRender(a => !a)
                                        let newnew = ServicesDataNewSubCategory.filter((a2 => a2.toLowerCase().includes(a.target.value.toLocaleLowerCase())))
                                        setRender(a => !a)
                                        setSearchQuery(a.target.value.toLocaleLowerCase())
                                        setServicesDataNew(newnew)
                                    }} />
                                <input
                                    type="number"
                                    inputMode="numeric"
                                    className="InputZipCode" placeholder="ZIP Code" defaultValue={ZipCode && ZipCode.length ? ZipCode : ""} value={ZipCode && ZipCode.length ? ZipCode : ""} onChange={(a) => {
                                        setRender(a => !a)
                                        setZipCode(a.target.value)
                                        setRender(a => !a)
                                        setUpdateApp(a => !a)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <a className="HomePageTopBannerTextRequesst" href={`/start-project`} >Find Pro</a>
                </div>
                {ShowSearch ?
                    <div className="HomePageTopBannerTextInputSearchResults" >
                        <div className="HomePageTopBannerTextInputSearchResultsList">
                            {

                                ServicesDataNew.length > 0 ?
                                    ServicesDataNew.map((A, Index) =>
                                        <a href={`/request-service?service=${A}`} className="HomePageTopBannerTextInputSearchResultsListBox">
                                            <img className="HomePageTopBannerTextInputSearchResultsListBoxImg" src={require(`../../Images/search.png`)} alt="Chimney Cleaning" />
                                            <a href={`/request-service?service=${A}${ZipCode ? `&zipcode=${ZipCode}` : "noe"}`}>{A}</a>
                                        </a>
                                    )
                                    :
                                    <div className="HomePageTopBannerTextInputSearchResultsListBox">
                                        <img className="HomePageTopBannerTextInputSearchResultsListBoxImg" src={require(`../../Images/search.png`)} />
                                        <a >No results</a>
                                    </div>
                            }

                        </div>

                    </div>
                    : null}
                <img src={require(`../../Images/TrustPilot.png`)} onMouseDown={() => {
                    setShowSearch(false)
                    setRender(a => !a)

                }} />
            </div>

            {/* HomePageOpenProjects */}
            {ProjectList.length ?
                <div className="HomePageOpenProjects" onMouseDown={() => {
                    setShowSearch(false)
                    setRender(a => !a)

                }}>
                    <h1>Pick up where you left off</h1>
                    <div className="HomePageOpenProjectsMain">

                        <div className="HomePageOpenProjectsLeft">
                            <h2>Based on your recent search</h2>
                            <h3>You have pending projects.</h3>
                            <a href={UserSession && UserSession.FirstName ? '/account/projects' : '/my-projects'}>My Projects</a>
                        </div>
                        <div className="HomePageOpenProjectsRight">

                        </div>
                    </div>

                </div>
                : null}
            {/* HomePageCategories */}
            <div className="HomePageCategories" onMouseDown={() => {
                setShowSearch(false)
                setRender(a => !a)

            }}>
                <h1>Popular services near you</h1>
                <div className="HomePageCategoriesList">
                    <div className="HomePageCategoriesListMore">
                        <a href='/request-service?service=Chimney-Fireplace' className="HomePageCategoriesListBox">
                            <div className="HomePageCategoriesListBoxImg">
                                <img src={require(`../../Images/chimney.png`)} alt="Chimney Cleaning" />
                            </div>
                            <div className="HomePageCategoriesListBoxBox">
                                <h2>Chimney Sweep</h2>
                                <h3> <img src={require(`../../Images/star.png`)} alt="Chimney Cleaning" />4.6 (10k+)</h3>
                            </div>
                        </a>
                        <a href='/request-service?service=Garage-Door' className="HomePageCategoriesListBox">
                            <div className="HomePageCategoriesListBoxImg">
                                <img src={require(`../../Images/garage.png`)} alt="Chimney Cleaning" />
                            </div>
                            <div className="HomePageCategoriesListBoxBox">
                                <h2>Garage Door</h2>
                                <h3> <img src={require(`../../Images/star.png`)} alt="Chimney Cleaning" />4.6 (10k+)</h3>
                            </div>
                        </a>
                        <a href='/request-service?service=Locksmith' className="HomePageCategoriesListBox">
                            <div className="HomePageCategoriesListBoxImg">
                                <img src={require(`../../Images/locksmith.png`)} alt="Chimney Cleaning" />
                            </div>
                            <div className="HomePageCategoriesListBoxBox">
                                <h2>Locksmith</h2>
                                <h3> <img src={require(`../../Images/star.png`)} alt="Chimney Cleaning" />4.6 (10k+)</h3>
                            </div>
                        </a>
                        <a href='/request-service?service=Roofing' className="HomePageCategoriesListBox">
                            <div className="HomePageCategoriesListBoxImg">
                                <img src={require(`../../Images/roofing.png`)} alt="Chimney Cleaning" />
                            </div>
                            <div className="HomePageCategoriesListBoxBox">
                                <h2>Roofing</h2>
                                <h3> <img src={require(`../../Images/star.png`)} alt="Chimney Cleaning" />4.6 (10k+)</h3>
                            </div>
                        </a>
                    </div>
                    <div className="HomePageCategoriesListMore">

                        <a href='/request-service?service=Air-Duct' className="HomePageCategoriesListBox">
                            <div className="HomePageCategoriesListBoxImg">
                                <img src={require(`../../Images/airduct.png`)} alt="Chimney Cleaning" />
                            </div>
                            <div className="HomePageCategoriesListBoxBox">
                                <h2>Air Duct</h2>
                                <h3> <img src={require(`../../Images/star.png`)} alt="Chimney Cleaning" />4.6 (10k+)</h3>
                            </div>
                        </a>
                        <a href='/request-service?service=Dryer-Vent' className="HomePageCategoriesListBox">
                            <div className="HomePageCategoriesListBoxImg">
                                <img src={require(`../../Images/dryervent.png`)} alt="Chimney Cleaning" />
                            </div>
                            <div className="HomePageCategoriesListBoxBox">
                                <h2>Dryer Vent</h2>
                                <h3> <img src={require(`../../Images/star.png`)} alt="Chimney" />4.6 (10k+)</h3>
                            </div>
                        </a>
                        <a href='/request-service?service=HVAC' className="HomePageCategoriesListBox">
                            <div className="HomePageCategoriesListBoxImg">
                                <img src={require(`../../Images/hvac.png`)} alt="Chimney" />
                            </div>
                            <div className="HomePageCategoriesListBoxBox">
                                <h2>HVAC</h2>
                                <h3> <img src={require(`../../Images/star.png`)} alt="Chimney" />4.6 (10k+)</h3>
                            </div>
                        </a>
                        <a href='/request-service?service=Insulation' className="HomePageCategoriesListBox">
                            <div className="HomePageCategoriesListBoxImg">
                                <img src={require(`../../Images/construction.png`)} alt="Chimney" />
                            </div>
                            <div className="HomePageCategoriesListBoxBox">
                                <h2>Insulation</h2>
                                <h3> <img src={require(`../../Images/star.png`)} alt="Chimney Cleaning" />4.6 (10k+)</h3>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            {/* HomePageSignUp */}
            <div className="HomePageSignUp" onMouseDown={() => {
                setShowSearch(false)
                setRender(a => !a)

            }}>
                <div className="HomePageSignUpBox">
                    <div className="HomePageSignUpLeft">
                        <h1>Knowledge is priceless - so our cost guides are free.</h1>
                        <h2>Sign up to get free project cost info in your inbox.</h2>
                    </div>
                    <div className="HomePageSignUpRight">
                        <input placeholder="Email Address" type="text" />
                        <button>Sign me up</button>
                    </div>
                </div>
            </div>
            {/* HomePageServices */}
            <div className="HomePageServices" onMouseDown={() => {
                setShowSearch(false)
                setRender(a => !a)

            }}>
                <h1>Top services</h1>
                <div className="HomePageServicesList" ref={containerRefService}>
                    <a href="/category/Chimney-Fireplace" className="HomePageServicesListBox">
                        <img src={require(`../../Images/1-chimney.jpg`)} alt="Chimney Cleaning" />
                        <div className="HomePageServicesListBoxBox">
                            <h2>Chimney Sweep</h2>
                        </div>
                    </a>
                    <a href="/category/Garage-Door" className="HomePageServicesListBox">
                        <img src={require(`../../Images/1-garage.jpg`)} alt="Chimney Cleaning" />
                        <div className="HomePageServicesListBoxBox">
                            <h2>Garage Door</h2>
                        </div>
                    </a>
                    <a href="/category/Locksmith" className="HomePageServicesListBox">
                        <img src={require(`../../Images/1-locksmith.jpg`)} alt="Chimney Cleaning" />
                        <div className="HomePageServicesListBoxBox">
                            <h2>Locksmith</h2>
                        </div>
                    </a>
                    <a href="/category/Roofing" className="HomePageServicesListBox">
                        <img src={require(`../../Images/1-roofing.jpg`)} alt="Chimney Cleaning" />
                        <div className="HomePageServicesListBoxBox">
                            <h2>Roofing</h2>
                        </div>
                    </a>
                    <a href="/category/Air-Duct" className="HomePageServicesListBox">
                        <img src={require(`../../Images/1-airduct.jpg`)} alt="Chimney " />
                        <div className="HomePageServicesListBoxBox">
                            <h2>Air Duct </h2>
                        </div>
                    </a>
                    <a href="/category/Dryer-Vent" className="HomePageServicesListBox">
                        <img src={require(`../../Images/1-dryervent.jpg`)} alt="Chimney" />
                        <div className="HomePageServicesListBoxBox">
                            <h2>Dryer Vent</h2>
                        </div>
                    </a>
                    <a href="/category/HVAC" className="HomePageServicesListBox">
                        <img src={require(`../../Images/1-hvac.jpg`)} alt="Chimney Cleaning" />
                        <div className="HomePageServicesListBoxBox">
                            <h2>HVAC</h2>
                        </div>
                    </a>
                    <a href="/category/Insulation" className="HomePageServicesListBox">
                        <img src={require(`../../Images/1-insulation.jpg`)} alt="Chimney Cleaning" />
                        <div className="HomePageServicesListBoxBox">
                            <h2>Insulation</h2>
                        </div>
                    </a>
                </div>
                <div className="HomePageServicesListSCrollRight" onClick={scrollRightService}>
                    <img src={require(`../../Images/next.png`)} />
                </div>
            </div>
            {/* CategoryHowMatchWork */}
            <div className="CategoryHowMatchWork">
                <h1>How HandyBy Work?</h1>
                <div className="CategoryHowMatchWorkList">
                    <div className="CategoryHowMatchWorkBox">
                        <div className="CategoryHowMatchWorkBoxBox1">
                            <div className="CategoryHowMatchWorkBoxBox1Back">
                                <h2>Create a Project</h2>
                                <h3>Find a qualified pro for the exact service you’re looking for :)</h3>
                                <h4>Roofing contractor near me |</h4>
                            </div>
                        </div>
                        <h2>Tell Us What You Need</h2>
                        <h3>Submit a quick project request with the service you’re looking for.</h3>
                    </div>
                    <div className="CategoryHowMatchWorkBox">
                        <div className="CategoryHowMatchWorkBoxBox2">
                            <h4>You have new project</h4>
                            <img className="" src={require(`../../Images/howitwork2.png`)} />
                        </div>
                        <h2>Get Matched with a HandyBy Pro</h2>
                        <h3>We connect you with a qualified, local contractor who can get it done.</h3>
                    </div>
                    <div className="CategoryHowMatchWorkBox">
                        <div className="CategoryHowMatchWorkBoxBox3">
                            <img className="" src={require(`../../Images/contractorProfile.jpeg`)} />
                            <h4>🚘 &nbsp; A HandyBy Pro Is On The Way...</h4>
                        </div>
                        <h2>Post your task</h2>
                        <h3>Your HandyBy Pro shows up ready to work. No surprises work, only starts once you both agree on the price.

                        </h3>
                    </div>
                </div>
                <a href="/start-project">Find pro</a>
            </div>

            {/* CategoryProjects */}
            {/* <div className="CategoryProjects">
                <h1>Recent projects done by HandyBy's roofing pros</h1>
                <div className="CategoryProjectsList" ref={containerRefProjects}>
                    {arr.map(item => {
                        return <div key={item} className="CategoryProjectsBox">
                            <h2>Post your task</h2>
                            <h3>Tell us what you need, it's FREE to post.</h3>
                            <img src={require(`../../Images/1-roofing.jpg`)} alt="Chimney Cleaning" />
                        </div>
                    })}
                </div>
                <div className="HomePageServicesListSCrollRight" onClick={scrollRightProjects}>
                    <img src={require(`../../Images/next.png`)} />
                </div>
            </div> */}

            {/* HomePageStartProject */}
            <div className="HomePageStartProject">
                <div className="MyProjectsHeaderLeft">
                    <h1>Start a Project</h1>
                    <h2>Find a Local Pro for Your Project</h2>
                    <a href="/start-project"> <img src={require(`../../Images/construction.png`)} alt="Chimney Cleaning" /> Create Project</a>
                </div>
                <img src={require(`../../Images/document.png`)} alt="Chimney Cleaning" />
            </div>

        </div>
    )
}

